function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.75308 0 0 .59782 17.542 25.779)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("line", {
  x1: 32.867,
  x2: 32.867,
  y1: 2.923,
  y2: 23.643
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.736 124.31c-17.57-9.304-30.059-33-30.059-60.764 0-27.82 12.539-51.558 30.167-60.821 17.627 9.264 30.213 33.001 30.213 60.821 0 27.764-12.486 51.46-30.059 60.764z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.886 23.765 22.899 33.251 16.908 63.46"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "2.678 63.46 10.417 45.235 12.913 22.517 32.886 12.28 26.395 6.787"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16.908 63.46 10.417 45.235 22.899 33.251 32.886 12.28"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.667,
  x2: 5.174,
  y1: 45.484,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.821 23.765 42.809 33.251 48.799 63.46"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "63.027 63.46 55.29 45.235 52.793 22.517 32.821 12.28 39.312 6.787"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "48.799 63.46 55.29 45.235 42.809 33.251 32.821 12.28"
}), /*#__PURE__*/React.createElement("line", {
  x1: 55.04,
  x2: 60.532,
  y1: 45.484,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.886 103.19 22.899 93.706 16.908 63.496"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "2.678 63.496 10.417 81.721 12.913 104.44 25.39 107.87 26.395 120.17"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16.908 63.496 10.417 81.721 22.899 93.706 25.39 107.87"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.667,
  x2: 5.174,
  y1: 81.472,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.821 103.19 42.809 93.706 48.799 63.496"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "63.027 63.496 55.29 81.721 52.793 104.44 40.296 107.87 39.312 120.17"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "48.799 63.496 55.29 81.721 42.809 93.706 40.296 107.87"
}), /*#__PURE__*/React.createElement("line", {
  x1: 55.04,
  x2: 60.532,
  y1: 81.472,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polygon", {
  points: "40.449 107.72 32.867 103.14 25.572 107.72 32.867 124.32"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.75308 0 0 .59782 75.046 25.682)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("line", {
  x1: 32.867,
  x2: 32.867,
  y1: 2.923,
  y2: 23.643
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.736 124.31c-17.57-9.304-30.059-33-30.059-60.764 0-27.82 12.539-51.558 30.167-60.821 17.627 9.264 30.213 33.001 30.213 60.821 0 27.764-12.486 51.46-30.059 60.764z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.886 23.765 22.899 33.251 16.908 63.46"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "2.678 63.46 10.417 45.235 12.913 22.517 32.886 12.28 26.395 6.787"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16.908 63.46 10.417 45.235 22.899 33.251 32.886 12.28"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.667,
  x2: 5.174,
  y1: 45.484,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.821 23.765 42.809 33.251 48.799 63.46"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "63.027 63.46 55.29 45.235 52.793 22.517 32.821 12.28 39.312 6.787"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "48.799 63.46 55.29 45.235 42.809 33.251 32.821 12.28"
}), /*#__PURE__*/React.createElement("line", {
  x1: 55.04,
  x2: 60.532,
  y1: 45.484,
  y2: 43.488
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.886 103.19 22.899 93.706 16.908 63.496"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "2.678 63.496 10.417 81.721 12.913 104.44 25.39 107.87 26.395 120.17"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16.908 63.496 10.417 81.721 22.899 93.706 25.39 107.87"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.667,
  x2: 5.174,
  y1: 81.472,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polyline", {
  points: "32.821 103.19 42.809 93.706 48.799 63.496"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "63.027 63.496 55.29 81.721 52.793 104.44 40.296 107.87 39.312 120.17"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "48.799 63.496 55.29 81.721 42.809 93.706 40.296 107.87"
}), /*#__PURE__*/React.createElement("line", {
  x1: 55.04,
  x2: 60.532,
  y1: 81.472,
  y2: 83.469
}), /*#__PURE__*/React.createElement("polygon", {
  points: "32.867 124.32 40.449 107.72 32.867 103.14 25.572 107.72"
}));

const SvgMarquisePair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 142,
  height: 127.33,
  enableBackground: "new 0 0 66 127.333",
  viewBox: "0 0 142 127.33",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarquisePair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marquise-pair.1597f25d.svg";
export { ForwardRef as ReactComponent };